import React, { forwardRef, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { PillValue } from '../Pill/PillValue.esm.js';

const FilterValueButton = forwardRef((props, ref) => {
    const intl = useIntl();
    const { isOpen, items, label, disabled, selectedItemLabels, enableSelectAll, ...rest } = props;
    const selectableItemsCount = useMemo(() => {
        if (enableSelectAll) {
            return items.filter((item) => !item.disabled).length;
        }
        else {
            return null;
        }
    }, [enableSelectAll, items]);
    const displayValue = selectedItemLabels.length === selectableItemsCount
        ? intl.formatMessage({ id: "0jcnlJ", defaultMessage: [{ type: 0, value: "All" }] })
        : selectedItemLabels.map(String).join(", ");
    return (React.createElement(PillValue, { isFullWidth: rest.isFullWidth, labelKey: label, labelValue: displayValue, disabled: disabled, isOpen: isOpen, addClassName: "tw-rounded", required: rest.required, ref: ref, ...rest }));
});
FilterValueButton.displayName = "FilterValueButton";

export { FilterValueButton };
//# sourceMappingURL=FilterValueButton.esm.js.map
